import { render, staticRenderFns } from "./AppEnvironmentInfo.vue?vue&type=template&id=4612a772&scoped=true&"
import script from "./AppEnvironmentInfo.vue?vue&type=script&lang=js&"
export * from "./AppEnvironmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppEnvironmentInfo.vue?vue&type=style&index=0&id=4612a772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612a772",
  null
  
)

export default component.exports